import Partners from './views/Partners.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';


const routes = [
  {
    path: '/login/',
    name: 'login',
    component: Login,
    meta: {
      bgClass: 'bg-default-dark',
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/partners',
    name: 'partners',
    component: Partners,
    meta: {
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  // phase out pages;
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      bgClass: 'bg-phone',
      hideFooter: true,
      noPadding: true,
    },
  },
];


export default routes;
